import { render, staticRenderFns } from "./PlayRecording.vue?vue&type=template&id=66150b84&scoped=true&"
import script from "./PlayRecording.vue?vue&type=script&lang=js&"
export * from "./PlayRecording.vue?vue&type=script&lang=js&"
import style0 from "./PlayRecording.vue?vue&type=style&index=0&id=66150b84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66150b84",
  null
  
)

export default component.exports